import React from 'react';
import { connect } from 'react-redux';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { amplitudeEventForCompletedTopUp } from 'apps/auth/components/utils/AmplitudeUtils';
import BasePage from 'apps/auth/components/utils/BasePage';
import { topUpMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { DELIVERY_BANK_ACCOUNT } from 'apps/auth/constants/Constants';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { copyTextToClipboard, getFormattedCardOrAccountNumber } from 'apps/auth/helpers/utils';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const AccountDetails = (props) => {
    const { notNowButton, textShareDescription, title, paidButton, ...messages } = usePageMessages();
    const { account, sharedDetails, ...extra } = useExtra();
    const formattedIban = getFormattedCardOrAccountNumber(account.iban, DELIVERY_BANK_ACCOUNT);
    const formattedBic = getFormattedCardOrAccountNumber(account.bic, DELIVERY_BANK_ACCOUNT);

    const copyOnClick = (e, label, value) => {
        e.preventDefault();
        const result = copyTextToClipboard(value);
        if (result) {
            props.toggleSnackBar(true, `${label} ${messages.copied}`);
        }
    };

    const renderField = (label, value) => {
        return (
            <Row indent={'32px'}>
                <Text variant="div" size="secondary" color="secondary" indent="4px">
                    {label}
                </Text>
                <Text variant="div" size="main" indent="8px">
                    {value}
                </Text>
                <Text variant="link" href="#" color="primary" size="secondary" onClick={(e) => copyOnClick(e, label, value)}>
                    {messages.detailsCopy}
                </Text>
            </Row>
        );
    };

    const shareDetails = (header, text) => {
        navigator
            .share({ title: header, text })
            .then(() => logInfo('Successful share'))
            .catch((error) => logInfo('Error sharing', error));
    };

    const share = (e) => {
        e.preventDefault();
        shareDetails(messages.accountDetails, sharedDetails);
    };

    const renderShareDetails = () => (
        <Row indent={'32px'}>
            {__isBrowser__ && navigator && navigator.share && (
                <Text variant="link" href="#" color="primary" onClick={share}>
                    {messages.detailsShare}
                </Text>
            )}
        </Row>
    );

    return (
        <CommonPage
            showChat={false}
            rightHeaderComponent={
                <Button
                    type="link"
                    href={`${AUTH_GA_POCKET}${account.id}`}
                    size="tight"
                    variant="tertiary"
                    caption={notNowButton}
                    title={notNowButton}
                    onClick={(e) => {
                        e.preventDefault();
                        window.history.back();
                    }}
                />
            }
        >
            <HeaderPanel title={title} subtitle={textShareDescription} />
            {renderField(messages.detailsName, extra.userFullName)}
            {renderField(messages.ibanLabel, formattedIban)}
            {renderField(messages.bicLabel, formattedBic)}
            {renderShareDetails()}
            <FixedBottomPanel isRightAligned={true}>
                <Button
                    type="link"
                    raised={true}
                    href={`/auth/ga/pocket/${account.id}/top-up/bank-transfer/final-step`}
                    caption={paidButton}
                    title={paidButton}
                    onClick={() => {
                        amplitudeEventForCompletedTopUp(topUpMethods.BANK_TRANSFER);
                    }}
                />
            </FixedBottomPanel>
        </CommonPage>
    );
};

export default connect(null, { toggleSnackBar })(BasePage(AccountDetails));
